import {EMAIL_TEMPLATES_PATH} from "../../BarsENV/shell/constants";

export const TEMPLATES_LIST_PATH = `${EMAIL_TEMPLATES_PATH}/list`;
export const TEMPLATES_EXACT_PATH = `${EMAIL_TEMPLATES_PATH}/list/:id`;
export const TEMPLATES_CREATE_PATH = `${EMAIL_TEMPLATES_PATH}/create`;